import { render, staticRenderFns } from "./ModalMasive.vue?vue&type=template&id=2cdad808&"
import script from "./ModalMasive.vue?vue&type=script&lang=js&"
export * from "./ModalMasive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports